export default __webpack_public_path__ + "static/media/nav.1ec5d040.svg";